import { render, staticRenderFns } from "./DictonariesEditingRow.vue?vue&type=template&id=9f9edf30&scoped=true&"
import script from "./DictonariesEditingRow.vue?vue&type=script&lang=js&"
export * from "./DictonariesEditingRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9edf30",
  null
  
)

export default component.exports